export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/48c3d350a874654b9919fc00f7ab5f35.png";